<template>
  <div>
    <v-dialog
      v-if="isCurrentUser"
      v-model="dialog"
      persistent
      max-width="1000px"
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="green"
        title="Announcements"
        text="Unread announcements"
        class="mb-0"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="announcements"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.title="{ item }">
                  <div>
                    <a
                      style="color:black"
                      class="font-weight-bold"
                      @click="loadAnnouncement(item.id)"
                    >
                      {{ item.title }}  
                    </a>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-skeleton-loader
      :loading="skeleton"
      class="mx-auto my-5"
      type="card"
    >
      <viewer 
        ref="viewer"
        :images="images"   
        :options="viewerOptions" 
        @inited="imageViewerInited"            
      >
        <template slot-scope="scope">
          <img 
            v-for="src in scope.images"
            v-show="false"             
            :key="src" 
            :src="src"
          >
        </template>
      </viewer>
      <material-card class="v-card-profile"> 
        <v-avatar
          slot="offset"  
          v-ripple
          class="mx-auto d-block cursor-pointer"     
          size="130"            
        >
          <img
            v-if="!avatar"
            :src="thumbnailUrl"
            onerror="this.src='img/thumbnail.jpg'"
            @click="showViewer"
          >
          <v-img
            v-else
            :src="avatar.imageURL"
          />            
        </v-avatar>                        
        <v-slide-x-transition>
          <div 
            v-if="avatar && saved == false"
            class="text-center"
          >         
            <v-btn 
              :disabled="saving"
              text
              icon
              @click="avatar = null"
            >
              <v-icon size="30">
                mdi-close-circle-outline
              </v-icon>
            </v-btn>     
            <v-btn 
              :loading="saving"
              text
              icon
              color="primary"
              @click="uploadImage"
            >
              <v-icon size="30">
                mdi-cloud-upload
              </v-icon>
            </v-btn>
          </div>
        </v-slide-x-transition>
        <v-card-text class="text-center">
          <h6 class="category text-gray font-weight-thin mb-4">
            <!-- {{ (employeePosition.position || {}).name }} -->
          </h6> 
          <h4 class="font-weight-bold">
            {{ name }}
          </h4>
          <p 
            v-if="departments" 
            class="font-weight-medium"
          >
            {{ departments }} 
          </p>      
          <!-- <div v-if="!_.isEmpty(employeePosition)">  
            <v-divider class="my-2" />        
            <span class="font-weight-medium amber--text text--darken-1">{{ (employeePosition.grade || {}).name }}</span> 
            <span class="font-italic"> - Rank {{ ((employeePosition.grade || {}).rank || {}).value }} </span>
            <v-card-actions class="profile-card-action py-0">
              <v-tooltip top>    
                <template v-slot:activator="{ on }">          
                  <v-avatar
                    size="36px"
                    class="mr-2"
                    v-on="on"
                  >
                    <img 
                      :src="((employeePosition.grade || {}).rank || {}).image_url" 
                    >
                  </v-avatar>
                </template>
                Since <span class="font-italic">{{ $moment((employeePosition || {}).created_at, 'YYYY-MM-DD').format('MMM YYYY') }}</span>
              </v-tooltip>
              <v-progress-linear
                :value="progressPercentage"
                color="amber"
                height="25"
              >
                <strong>{{ progress || 0 }} / {{ requirements.length || 0 }}</strong> 
                <v-icon
                  small
                  class="mx-1"
                  color="black"
                >
                  mdi-briefcase-check
                </v-icon>
              </v-progress-linear>
               <employee-positions-requirement-overview-dialog             
                :position-id="employeePosition.position_id"
                :grade-id="employeePosition.position_category_rank_id"
                :employee-uid="employeeUid"
              /> 
            </v-card-actions>
          </div>         -->
        </v-card-text>
        <!-- <v-divider class="mt-2" /> -->
        <!-- <div 
          v-if="filteredAwards.length > 0"
        >
          <v-row>
            <v-col 
              cols="1"
            >
              <v-btn
                text
                icon
                color="purple"
                @click="scrollLeft"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
            <v-col 
              class="pt-2" 
              :cols="$vuetify.breakpoint.lgOnly ? '9' : '10'"
            >
              <div
                :class="{
                  'wrapper-box-xs': $vuetify.breakpoint.smAndDown,
                  'wrapper-box-md': $vuetify.breakpoint.mdOnly,
                  'wrapper-box-lg': $vuetify.breakpoint.lgOnly,
                  'wrapper-box': $vuetify.breakpoint.xlOnly
                }"
              >
                <v-row 
                  :style="filteredAwards.length < 7 ? 'justify-content: center;' : ' '"
                  class="award-box flex-nowrap"
                >
                  <span
                    v-for="(employeeAwards, i) in filteredAwards"
                    :key="i"
                    class="px-4 py-4"
                  >
                    <employee-awards-popover
                      :employee-uid="employeeUid"
                      :employee-award="employeeAwards"
                      @deleted="loadEmployeeAward"
                    />
                  </span>
                </v-row>  
              </div>
            </v-col>
            <v-col cols="1">
              <v-btn
                text
                icon
                color="purple"
                @click="scrollRight"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
        </div> -->
        <v-card-actions>
          <v-row justify="center">
            <!-- <v-col
              v-if="canChangePhoto()" 
              cols="2"
              xl="1"
            >
              <helper-image-input      
                v-model="avatar"
                :max-size-in-mb="2"
                field-name="avatar"
                accept-type="image/*"            
              >          
                <v-btn                
                  slot="activator"
                  :disabled="saving"
                  icon
                  color="primary"
                >
                  <v-icon> mdi-camera </v-icon>
                </v-btn>
              </helper-image-input> 
            </v-col> -->

            <!--<v-col
              v-if="canAssignPosition()"
              cols="2"
              xl="1"
            >
               <employee-positions-dialog-create               
                :employee-uid="employeeUid"
                @assigned="loadEmployeePosition"
              /> 
            </v-col>-->

            <!--<v-col
              v-if="canAssignAward()"
              cols="2"
              xl="1"
            >
               <employee-awards-dialog-create
                :employee-uid="employeeUid"
                @added="loadEmployeeAward"
              /> 
            </v-col>-->

            <!-- <v-col
              v-if="canChangeDepartment()"
              cols="2"
              xl="1"
            >
              <employee-departments-dialog-edit
                :employee="employee"
                @updated="loadEmployee"
              />
            </v-col> -->

            <!-- <v-col
              v-if="canChangeWorkdaySession()"
              cols="2"
              xl="1"
            >
              <employee-workdays-dialog-edit
                :employee-uid="employeeUid"
                @updated="loadEmployee"
              />
            </v-col> -->

            <!-- <v-col
              v-if="hasAction()"
              cols="2"
              xl="1"
            >
              <v-divider
                vertical
              />
            </v-col> -->

            <!--<v-col
              v-if="canViewCareerHistory()"
              cols="2"
              xl="1"
            >
               <employee-positions-dialog-list 
                :employee-uid="employeeUid"
              /> 
            </v-col>-->

            <!-- <v-col
              cols="2"
              xl="1"
            >
              <employee-awards-dialog-list
                :employee-uid="employeeUid"
                :no-of-awards="noOfAwards"
              />
            </v-col> -->
            <!-- <v-col
              v-if="canViewWorkdaySession()"
              cols="2"
              xl="1"
            >
              <employee-workdays-dialog-list 
                :employee-uid="employeeUid"
              />
            </v-col> -->
          </v-row>
        </v-card-actions>
      </material-card>
    </v-skeleton-loader>      
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      // HelperImageInput: () => import('@/components/helper/ImageInput'),
      // EmployeeWorkdaysDialogList: () => import('@/components/employee/workdays/DialogList'),
      // EmployeeAwardsDialogList: () => import('@/components/employee/awards/DialogList'),
      // EmployeePositionsDialogList: () => import('@/components/employee/positions/DialogList'),
      // EmployeeWorkdaysDialogEdit: () => import('@/components/employee/workdays/DialogEdit'),
      // EmployeeDepartmentsDialogEdit: () => import('@/components/employee/departments/DialogEdit'),
      // EmployeeAwardsDialogCreate: () => import('@/components/employee/awards/DialogCreate'),
      // EmployeePositionsDialogCreate: () => import('@/components/employee/positions/DialogCreate'),
      // EmployeeAwardsPopover: () => import('@/components/employee/awards/Popover'),
      // EmployeePositionsRequirementOverviewDialog: () => import('@/components/employee/positions/RequirementOverviewDialog'),
    },
    props: {
      userUid: {
        type: String,
        default: '',
      },
      employeeUid: {
        type: String,
        default: '',
      },
      personUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: false,
        announcements: [],
        headers: [
          {
            text: 'Announcement Title',
            align: 'left',
            value: 'title',
            sortable: false,
          },
          {
            text: 'Announcement Date',
            align: 'center',
            value: 'announcement_date',
            sortable: false,

          },
          {
            text: 'Announcement By',
            align: 'center',
            value: 'created_by',
            sortable: false,
          },
        ],

        user: {},
        person: {},
        employee: {},
        employeePosition: {},
        skills: [],
        requirements: [],
        employeeAward: [],
        department: {},
      
        viewerOptions: {       
          navbar: 0,
          movable: 0,
          rotatable: 0,
          title: 3,
        
          toolbar: {
            zoomIn: 2,
            zoomOut: 2,
            reset: 2,
            play: {
              show: 2,
              size: 'large',
            },

            oneToOne: 0,
            prev: 0,
            next: 0,
            rotateLeft: 0,
            rotateRight: 0,
            flipHorizontal: 0,
            flipVertical: 0,
          },
        },
        avatar: null,
        defaultAvatar: 'img/thumbnail.jpg',
        saving: false,
        saved: false,
        skeleton: true,
      }
    },
    computed: {
      ...mapState('lookup', ['place_of_birth']),
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      images () {
        return [ this.avatarUrl ]
      },
      avatarUrl () {
        return this.employee.avatar_url
      },
      // filteredAwards () {
      //   return this.employeeAward.filter(employeeAwards => {
      //     return this.$moment((employeeAwards || {}).created_at, 'YYYY-MM-DD').format('YYYY') === this.$moment().format('YYYY')
      //   })
      // },
      // noOfAwards () {
      //   return this.employeeAward.length
      // },
      departments () {
        return this.department.name
      },
      thumbnailUrl () {
        return this.employee.thumbnail_url || this.defaultAvatar
      },
      name () {
        return this.person.name || 'Name'
      },
      placeOfBirth () {
        return (this.place_of_birth.find(placeOfBirth => {
          return placeOfBirth.lookup_uid === this.person.dob_state_lookup_uid 
        }) || {}).value || 'Sarawak'
      },
      // progress () {
      //   const total = this.requirements.reduce((accumulator, currentValue) => {
      //     let fullfilled = true
        
      //     currentValue.skill_levels.map(skillLevel => {
      //       const skill = this.skills.find(skill => skill.skill_id === skillLevel.skill_id)

      //       if (!skill || !(skill.skill_level.level >= skillLevel.level)) {
      //         fullfilled = false
      //       }
      //     })

      //     if (fullfilled) return accumulator + 1  
        
      //     return accumulator     
      //   }, 0)

      //   return total
      // },
      // progressPercentage () {
      //   return (this.progress / this.requirements.length) * 100 || 0
      // },
    },
    watch: {
      avatar: {
        handler (newValue) {
          this.saved = false
        },
        deep: true,
      },
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadEmployee()
            this.loadEmployeePosition()
            this.loadEmployeeSkills()
            // this.loadEmployeeAward()
            this.loadAnnouncementEmployees()
          }
        },
      },
      personUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadPerson()
          }
        },
      },
    },
    methods: {      
      uploadImage () {
        this.saving = true

        this.$api.employees().uploadAvatar(this.employeeUid, this.avatar.formData)
          .then(res => {
            if (res.status >= 200 && res.status < 300) {   
              if (this.isCurrentUser) {
                this.$store.dispatch('getCurrentUser')
              }
              this.loadEmployee()
              this.savedAvatar()  
            }          
          })
          .catch(() => {
            this.saving = false
            this.$snack({
              color: 'error',
              message: 'Photo upload failed, please try again',
            })
          }) 
      },
      loadEmployee () {
        this.$api.employees().show(this.employeeUid)
          .then(response => {
            this.employee = response.data
            if (this.employee.department_id) {
              this.$api.departments().show(this.employee.department_id)
                .then(response => {
                  this.department = response.data
                  this.skeleton = false
                })
            }
          })
      },
      loadEmployeeAward () {
        this.$api.employeeAwards().show(this.employeeUid)
          .then(response => {
            this.employeeAward = response.data
          })
      },    
      loadEmployeePosition () {
        this.$api.employeePositions().show(this.employeeUid)
          .then(response => {
            this.employeePosition = response.data

            // this.$api.positionJobRequirements().list(this.employeePosition.position_id, this.employeePosition.position_category_rank_id)
            //   .then(response => {
            //     this.requirements = this.groupJobDescriptions(response.data)
            //   })
          })
      },
      loadEmployeeSkills () {
        this.$api.employeeSkills().list(this.employeeUid)
          .then(response => {
            this.skills = response.data
          })
      },
      loadPerson () {
        this.$api.persons().show(this.personUid)
          .then(response => {
            this.person = response.data
            this.skeleton = false
          })
      },
      loadAnnouncementEmployees () {
        this.$api.employeeAnnouncements().list('false')
          .then(response => {
            this.announcements = _.orderBy(response.data, ['created_at'], ['desc'])  
            if (this.announcements.length > 0) {
              this.dialog = true
            }
          })
      }, 
      loadAnnouncement (id) {
        this.$api.announcements().show(id)
          .then(announcement => {
            if (announcement.data && !announcement.data.acknowledgement_required) {
              this.$api.employeeAnnouncements().markAsRead(id)
                .then(res => {
                  this.$router.push({ path: '/announcements/' + id })
                })
            } else {
              this.$router.push({ path: '/announcements/' + id })
            }
          })
      },
      groupJobDescriptions (requirements) {
        return requirements.reduce((accumulator, requirement) => {
          let index = accumulator.findIndex(item => item.job_requirement.job_description_id === requirement.job_requirement.job_description_id)
        
          let requirementCopy = { ...requirement }
          let skillLevel = { ...requirementCopy.skill_level }
        
          delete requirementCopy.skill_level
          delete requirementCopy.skill_level_id

          if (index === -1) {
            accumulator.push({ ...requirementCopy, skill_levels: [ { ...skillLevel, position_job_requirement_id: requirement.id } ] })
          } else {
            accumulator[index].skill_levels.push({ ...skillLevel, position_job_requirement_id: requirement.id })
          }

          return accumulator
        }, [])
      },
      savedAvatar () {
        this.avatar = null
        this.saving = false
        this.saved = true
        this.$snack({
          message: 'Photo uploaded successfully!',
        })
      },
      // hasAction () {
      //  return this.canAssignAward() || this.canAssignPosition() || this.canChangePhoto() || this.canChangeDepartment()
      // },
      // canAssignAward () {
      //   return !this.isCurrentUser && this.$hasPermissionTo(['assign award section'])
      // },
      // canAssignPosition () {
      //   return !this.isCurrentUser && this.$hasPermissionTo(['create employee positions'])
      // },
      // canChangePhoto () {
      //   return this.isCurrentUser || this.$hasPermissionTo(['update employee avatars'])
      // },
      // canChangeDepartment () {
      //   return !this.isCurrentUser && this.$hasPermissionTo(['update whole employees'])
      // },
      // canChangeWorkdaySession () {
      //   return !this.isCurrentUser && this.$hasPermissionTo(['update employee workdays'])
      // },
      // canViewCareerHistory () {
      //   return this.isCurrentUser || this.$hasPermissionTo(['list employee positions'])
      // },
      // canViewWorkdaySession () {
      //   return !this.isCurrentUser && this.$hasPermissionTo(['list employee workdays'])
      // },
      imageViewerInited (viewer) {
        this.$viewer = viewer
      },
      showViewer () {
        this.$viewer.show()
      },
      scrollLeft () {
        if (this.$vuetify.breakpoint.smAndDown) document.querySelector('.wrapper-box-xs').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.mdOnly)document.querySelector('.wrapper-box-md').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.lgOnly)document.querySelector('.wrapper-box-lg').scrollLeft -= 200
        else document.querySelector('.wrapper-box').scrollLeft -= 200
      },
      scrollRight () {
        if (this.$vuetify.breakpoint.smAndDown) document.querySelector('.wrapper-box-xs').scrollLeft += 200
        else if (this.$vuetify.breakpoint.mdOnly)document.querySelector('.wrapper-box-md').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.lgOnly)document.querySelector('.wrapper-box-lg').scrollLeft += 200
        else document.querySelector('.wrapper-box').scrollLeft += 200
      },
    },
  }
</script>
<style scoped>
.award-box {
  align-items:center;
  height:45px;
}
.wrapper-box {
  width:21vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-lg {
  width:18vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-md {
  width:21vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-xs {
  width:72vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box::-webkit-scrollbar {
    display: none;
}

.profile-card-action img {
  box-shadow: none;
}

.cursor-pointer{
  cursor: pointer;
}
</style>
